import { Environments } from '@/config';
import { HELIX_SANFORD_PRODUCTION } from './helix-sanford.production';
import { HELIX_SANFORD_STAGING } from './helix-sanford.staging';

export const HELIX_SANFORD =
  import.meta.env.MODE === Environments.PROD ? HELIX_SANFORD_PRODUCTION : HELIX_SANFORD_STAGING;
